import { LicenseType } from '@trip-ux/constants';

export const CREATE_AGENCY_LICENSE = 'CREATE_AGENCY_LICENSE';
export const CREATE_AGENT_LICENSE = 'CREATE_AGENT_LICENSE';
export const CREATE_AGENCY_LICENSE_FAILED = 'CREATE_AGENCY_LICENSE_FAILED';
export const CREATE_AGENT_LICENSE_FAILED = 'CREATE_AGENT_LICENSE_FAILED';
export const CREATE_AGENCY_LICENSE_START = 'CREATE_AGENCY_LICENSE_START';
export const CREATE_AGENT_LICENSE_START = 'CREATE_AGENT_LICENSE_START';
export const GET_AGENT_LICENSE_START = 'GET_AGENT_LICENSE_START';
export const GET_AGENCY_LICENSE_START = 'GET_AGENCY_LICENSE_START';
export const GET_AGENT_LICENSE = 'GET_AGENT_LICENSE';
export const GET_AGENCY_LICENSE = 'GET_AGENCY_LICENSE';
export const GET_AGENT_LICENSE_FAILED = 'GET_AGENT_LICENSE_FAILED';
export const GET_AGENCY_LICENSE_FAILED = 'GET_AGENCY_LICENSE_FAILED';
export const UPDATE_AGENT_LICENSE_START = 'UPDATE_AGENT_LICENSE_START';
export const UPDATE_AGENCY_LICENSE_START = 'UPDATE_AGENCY_LICENSE_START';
export const UPDATE_AGENT_LICENSE = 'UPDATE_AGENT_LICENSE';
export const UPDATE_AGENCY_LICENSE = 'UPDATE_AGENCY_LICENSE';
export const UPDATE_AGENT_LICENSE_FAILED = 'UPDATE_AGENT_LICENSE_FAILED';
export const UPDATE_AGENCY_LICENSE_FAILED = 'UPDATE_AGENCY_LICENSE_FAILED';

export const LICENSE_TABLE_LENGTH_PER_PAGE = 10;

export interface LicenseSlice {
  isLicenseFailure: Boolean;
  isLicenseLoading: Boolean;
  isLicenseSuccess: Boolean;
  searchFilter: Partial<LicenseSearchFilter>;
  searchResult: Partial<License>[];
  searchResultTotalCount: number;
  sortField: string;
  sortOrder: 'asc' | 'desc';
  exportURL: string;
  isDownloadReady: Boolean;
  currentPage: number;
  totalPages: number;
  searchResultRaw: LicenseSearchResult[];
  filterStartingFields:string[];
}

export type LicenseSearchFilter = {
  organizationName: string;
  branchCode: string;
  firstName: string;
  lastName: string;
  profileCode: string;
  licensedProvince: string;
  name: string;
  legalName: string;
  licenseNumber: string;
  status: string;
  screeningStatus: string;
  expiredDateStart: Date;
  expiredDateEnd: Date;
};
export interface LicenseRequest {
  profileRef?: string;
  licenseNumber?: string;
  orgCode?: string;
  name?: string;
  lastName?: string;
  licenseType?: string;
  province?: string;
  effectiveDate?: string;
  expiryDate?: string;
  screeningEffectiveDate?: string;
  screeningStatus?: string;
  status?: string;
}

export interface License {
  id?: number;
  name?: string;
  licenseNumber?: string;
  licensedProvince?: string;
  expiryDate: Date;
  screeningEffectiveDate: string;
  screeningStatus: string;
  status: string;
  licenseType?: LicenseType;
  organizationCode?: string;
  profileRef?: string;
  isDeleted?: boolean;
}

export interface LicenseData {
  code?: string;
  email?: string;
  license: {
    id?: number;
    legalName?: string;
    licensedProvince?: string;
    expiryDate: Date;
    screeningEffectiveDate: string;
    screeningStatus: string;
    status: string;
    licenseType?: LicenseType;
    organizationCode?: string;
  };
}

export interface LicenseResponse {
  id: string;
  profileRef: string;
  profileType: string;
  userRef: string;
  profileCode: string;
  code: string;
  salesChannel: string;
  response: {
    code?: string;
    organizationName: string;
    city: string;
    country: string;
    email: string;
    employmentType: string;
    firstName: string;
    language: string;
    lastName: string;
    province: string;
    role: string;
    license: {
      id?: number;
      legalName?: string;
      licensedProvince?: string;
      expiredDate: Date;
      screeningEffectiveDate: string;
      screeningStatus: string;
      status: string;
      licenseType?: LicenseType;
      effectiveDate?: string;
      licenseNumber?: string;
      isDeleted?: boolean;
    };
  };
}
export interface LicenseStore {
  data?: LicenseResponse;
  error?: unknown;
  isLoading?: boolean;
}

export interface LicenseSearchResponse {
  totalCount: number;
  licenses: LicenseSearchResult[];
}

export interface LicenseSearchPayload {
  filter: LicenseSearchFilter;
  sortOrder?: 'asc' | 'desc';
  sortField?: string;
  limit?: Number;
  offset?: Number;
}

export interface LicenseSearchResult {
  organizationCode: string;
  firstName?: string;
  lastName?: string;
  profileRef?: string;
  id?: number;
  licenseNumber?: string;
  status?: LicenseStatus;
  licensedProvince: string;
  screeningStatus?: ScreeningStatus;
  name?: string;
  legalName?: string;
  effectiveDate?: Date;
  expiredDate?: Date;
  licenseType: LicenseType;
  BDM: string;
  affiliationCode?: string;
  organizationName: string;
  licensingEmail?: string | null;
  code?: string;
  branchCode?: null | string;
  isDeleted?: boolean;
}

export enum ScreeningStatus {
  Approved = 'APPROVED',
  InProgress = 'IN_PROGRESS',
  Na = 'NA'
}

export enum LicenseStatus {
  Authorized = 'AUTHORIZED',
  InProgress = 'IN_PROGRESS',
  RenewalPending = 'RENEWAL_PENDING'
}
